import React from 'react';
import { HashRouter, Switch } from 'react-router-dom';

import routes from '../../routes'

import "./App.css"
import Header from '../header/Header.component';

// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import Test from "../../components/test/test.js";
// import Overview from "../../components/projects/Overview.component";

class App extends React.Component {
  render() {
    return (
      // <Router>
      //   <Switch>
      //     <Route path="/" exact component={Overview} />
      //     <Route path="/test" exact component={Test} />
      //     {/* {routes} */}
      //   </Switch>
      // </Router>

      <HashRouter>
        <Header />
        <Switch>{routes}</Switch>
      </HashRouter>
    );
  }
}

export default App;
